import { PaymentTaskDetailComponent } from './payment-task-detail/payment-task-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaymentManagementComponent } from '@app/payment-management/payment-management/payment-management.component';
import { PaymentManagementDetailComponent } from '@app/payment-management/payment-management-detail/payment-management-detail.component';
import { NewPaymentComponent } from '@app/payment-management/new-payment/new-payment.component';

import { AuthenticationGuard } from '@app/core/guards/authentication.guard';
import { AdminGuard } from '@app/core/guards/admin.guard';
import { routesConstants } from '@app/shared/models/LinksView';

const routes: Routes = [
  { path: '', canActivate: [ AuthenticationGuard ], component: PaymentManagementComponent },
  { path: routesConstants.paymentManagement.detail + '/:paymentId/customer/:customerId', canActivate: [ AuthenticationGuard ], component: PaymentManagementDetailComponent },
  { path: routesConstants.paymentManagement.taskDetail + '/:paymentId/customer/:customerId', canActivate: [ AdminGuard ], component: PaymentTaskDetailComponent },
  { path: routesConstants.paymentManagement.newPayment, canActivate: [ AdminGuard ], component: NewPaymentComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentManagementRoutingModule { }
